const ENHealth = [
    {
        title: "What doctors have learned about fighting COVID-19",
        description: "In the six months since an entirely new coronavirus began spreading around the world, doctors and hospitals have learned a lot about how to treat patients with COVID-19, the potentially deadly disease caused by the virus.",
        url: "https://www.reuters.com/article/us-health-coronavirus-lessons-factbox/what-doctors-have-learned-about-fighting-covid-19-idUSKBN23Z04K",
        image: "http://s3.reutersmedia.net/resources/r/?m=02&d=20200628&t=2&i=1523907603&r=LYNXMPEG5R03K&w=1280",
        publishedAt: "June 28, 2020, 5:43 AM",
        source: {
            "url": "https://www.reuters.com/",
            "name": "Reuters"
        },
    },
    {
        title: "East Congo Ebola outbreak no longer an international emergency, says WHO",
        description: "The World Health Organization said on Friday that the Ebola outbreak in eastern Democratic Republic of Congo that was declared over on Thursday no longer constitutes an international public health emergency. The WHO declared the outbreak a Public Health Emergency of International Concern last July, about a year after it was first detected.",
        url: "https://www.reuters.com/article/us-health-ebola-congo/east-congo-ebola-outbreak-no-longer-an-international-emergency-says-who-idUSKBN23X2L5",
        image: "https://s3.reutersmedia.net/resources/r/?m=02&d=20200626&t=2&i=1523777773&r=LYNXMPEG5P1P5&w=1280",
        publishedAt: "June 26, 2020, 7:07 PM",
        source: {
            url: "https://www.reuters.com/",
            name: "Reuters"
        },
    },
    {
        title: "Taiwan investigates possible first local virus case in two months",
        description: "Taiwan has put more than 100 people under quarantine while it investigates its first possible local case of coronavirus infection in more than two months, a Japanese woman who tested positive last week, the government said on Wednesday.",
        url: "https://www.reuters.com/article/us-health-coronavirus-taiwan/taiwan-investigates-possible-first-local-virus-case-in-two-months-idUSKBN23V1ZW",
        image: "https://s4.reutersmedia.net/resources/r/?m=02&d=20200624&t=2&i=1523334790&r=LYNXMPEG5N1HV&w=1280",
        publishedAt: "June 24, 2020, 2:35 PM",
        source: {
            url: "https://www.reuters.com/",
            name: "Reuters"
        },
    },
    {
        title: "Japanese startup creates 'connected' face mask for coronavirus new normal",
        description: "As face coverings become the norm amid the coronavirus pandemic, Japanese startup Donut Robotics has developed an internet-connected “smart mask” that can transmit messages and translate from Japanese into eight other languages.",
        url: "https://www.reuters.com/article/us-health-coronavirus-japan-mask-technol/japanese-startup-creates-connected-face-mask-for-coronavirus-new-normal-idUSKBN23X190",
        image: "https://s2.reutersmedia.net/resources/r/?m=02&d=20200626&t=2&i=1523724056&r=LYNXMPEG5P0RH&w=1280",
        publishedAt: "June 26, 2020, 10:47 AM",
        source: {
            url: "https://www.reuters.com/",
            name: "Reuters"
        },
    },
    {
        title: "Racial inequalities in COVID-19 — the impact on black communities",
        description: "A couple of weeks ago, Medical News Today dove into some ways in which COVID-19 is affecting people of color and minority groups. We also interviewed Prof. Tiffany Green about how racial inequities play into the disparities observed during the pandemic.",
        url: "https://www.medicalnewstoday.com/articles/racial-inequalities-in-covid-19-the-impact-on-black-communities",
        image: "https://post.medicalnewstoday.com/wp-content/uploads/sites/3/2020/06/GettyImages-1204660024-1024x683.jpg",
        publishedAt: "June 5, 2020",
        source: {
            url: "https://www.medicalnewstoday.com/",
            name: "Medical News Today"
        },
    },
    {
        title: 'Exercise, Diet, Alcohol: New Guidelines Detail Best Ways to Reduce Cancer Risk',
        description: "The American Cancer Society has released new guidelines for reducing the risk of cancer. The recommendations include the latest research on diet and physical activity, as well as policy and systems changes that reduce barriers to healthy living.",
        url: "https://www.healthline.com/health-news/exercise-diet-alcohol-new-guidelines-detail-best-ways-to-reduce-cancer-risk",
        image: "https://post.healthline.com/wp-content/uploads/2020/06/Female_Running_Dog_1296x728-header.jpg",
        publishedAt: "June 22, 2020",
        source: {
            url: "https://www.healthline.com/",
            name: "healthline"
        },
    },
    {
        title: "Negative Thinking Can Harm Your Brain and Increase Your Dementia Risk",
        description: "In a new study, researchers at University College London say they have found repetitive negative thinking is linked to cognitive decline, a higher number of harmful protein deposits in the brain, and consequently a greater risk of dementia.",
        url: "https://www.healthline.com/health-news/negative-thinking-can-harm-brain-increase-dementia-risk",
        image: "https://post.healthline.com/wp-content/uploads/2020/06/Female_Sad_1296x728-header.jpg",
        publishedAt: "June 11, 2020",
        source: {
            url: "https://www.healthline.com/",
            name: "healthline"
        },
    },
    {
        title: "Blood donation: 'Completely altruistic, so much benefit to so many people'",
        description: "Why are blood donations so important, including during a pandemic? Who benefits from them? And what happens when a person goes to donate blood? To find out, Medical News Today interviewed consultant hematologist Dr. Joel Newman.",
        url: "https://www.medicalnewstoday.com/articles/blood-donation-completely-altruistic-so-much-benefit-to-so-many-people",
        image: "https://post.medicalnewstoday.com/wp-content/uploads/sites/3/2020/06/shutterstock_1031720017_header-1024x575.jpg",
        publishedAt: "June 11, 2020",
        source: {
            url: "https://www.medicalnewstoday.com/",
            name: "Medical News Today"
        },
    },
    {
        title: "An overview of diabetes types and treatments",
        description: "Diabetes is a condition that impairs the body’s ability to process blood glucose, otherwise known as blood sugar. In the United States, the estimated number of people over 18 years of age with diagnosed and undiagnosed diabetes is 30.2 million. The figure represents between 27.9 and 32.7 percent of the population.",
        url: "https://www.medicalnewstoday.com/articles/323627",
        image: "https://cdn-prod.medicalnewstoday.com/content/images/articles/323/323627/diabetes.jpg",
        publishedAt: "January 9, 2020",
        source: {
            url: "https://www.medicalnewstoday.com/",
            name: "Medical News Today"
        },
    },
    {
        title: "Diabetes: Past treatments, new discoveries",
        description: "Diabetes develops when the body does not produce enough insulin or cannot respond to it appropriately, leading to high levels of sugar in the blood. Managing blood sugar levels can be challenging, but ongoing research is increasing the chance of living a full life with diabetes.",
        url: "https://www.medicalnewstoday.com/articles/317484",
        image: "https://cdn-prod.medicalnewstoday.com/content/images/articles/317/317484/joseph-von-mering-br-image-credit-pd-us-br.jpg",
        publishedAt: "June 17, 2020",
        source: {
            url: "https://www.medicalnewstoday.com/",
            name: "Medical News Today"
        },
    },
    {
        title: "Hepatitis C outside the body and other virus facts",
        description: "The hepatitis C virus can live outside the body in some circumstances, but it is unusual to contract the virus this way.Hepatitis C is a viral infection that damages the liver. A person can contract the virus through contact with blood that contains it. The illness can vary from mild to life threatening.",
        url: "https://www.medicalnewstoday.com/articles/320337",
        image: "https://post.medicalnewstoday.com/wp-content/uploads/sites/3/2020/04/GettyImages-909591006_header-1024x575.jpg",
        publishedAt: "May 5, 2020",
        source: {
            url: "https://www.medicalnewstoday.com/",
            name: "Medical News Today"
        },
    },
    {
        title: "Travel Bans, Quarantines Don’t Stop COVID-19 Spread, but They Can Delay It",
        description: "COVID-19 cases are still on the rise in the United States, with the pandemic surging in many states in the South and West after the initial outbreaks in major cities such as New York and New Orleans.",
        url: "https://www.healthline.com/health-news/travel-bans-quarantines-dont-stop-covid1-9-spread-but-can-delay-it#State-restrictions-face-challenges",
        image: "https://post.healthline.com/wp-content/uploads/2020/06/Traveling_Masks_1296x728-header.jpg",
        publishedAt: "June 29, 2020",
        source: {
            url: "https://www.healthline.com/",
            name: "healthline"
        },
    },
    {
        title: "Sitting All Day May Increase Your Risk of Dying From Cancer",
        description: "Sitting for hours on end could heighten someone’s risk of later dying from cancer, according to a sobering new study of the relationship between inactivity and cancer mortality. The study was epidemiological, providing a snapshot of people’s lives, so it cannot prove cause and effect.",
        url: "https://www.nytimes.com/2020/06/24/well/move/sitting-sedentary-exercise-cancer-risk.html",
        image: "https://static01.nyt.com/images/2020/06/23/well/physed-sitting-cancer/physed-sitting-cancer-jumbo.jpg?quality=90&auto=webp",
        publishedAt: "June 24, 2020",
        source: {
            url: "https://www.nytimes.com/",
            name: "The New York Times"
        },
    },
    {
        title: "Vitamin D Supplements May Help People with Cancer Live Longer",
        description: 'Vitamin D supplements, if taken for multiple years, may add years of life to those with cancer. In a recent study conducted at Michigan State University, researchers found that vitamin D, if taken for at least three years, could help people with cancer live longer.',
        url: "https://www.healthline.com/health-news/vitamin-d-and-cancer-deaths",
        image: "https://post.healthline.com/wp-content/uploads/2019/06/Couple_Water_OverHead_1296x728-header-1296x728.jpg",
        publishedAt: "June 11, 2019",
        source: {
            url: "https://www.healthline.com/",
            name: "healthline"
        },
    },
    {
        title: "Fashion masks a hit as Indonesians, Malaysians seek style in safety",
        description: 'With no sign of the global coronavirus threat easing anytime soon, protective masks are fast becoming fashion accessories for Indonesians and Malaysians keen to add some style and humour to healthwear essentials.',
        url: "https://www.reuters.com/article/us-health-coronavirus-fashion-masks/fashion-masks-a-hit-as-indonesians-malaysians-seek-style-in-safety-idUSKBN23X0FE",
        image: "https://s4.reutersmedia.net/resources/r/?m=02&d=20200626&t=2&i=1523690737&r=LYNXMPEG5P07R&w=1280",
        publishedAt: "June 26, 2020, 4:51 AM",
        source: {
            url: "https://www.reuters.com/",
            name: "Reuters"
        },
    },
    {
        title: "J&J loses bid to overturn baby powder verdict, but damages cut to $2.12 billion",
        description: 'A Missouri appeals court on Tuesday rejected Johnson & Johnson’s bid to throw out a jury verdict in favor of women who blamed their ovarian cancer on its baby powder and other talc products, but reduced damages by more than half, to $2.12 billion.',
        url: "https://www.reuters.com/article/us-johnson-johnson-talc-lawsuit/jj-loses-bid-to-overturn-baby-powder-verdict-but-damages-cut-to-2-12-billion-idUSKBN23U2BB",
        image: "https://s4.reutersmedia.net/resources/r/?m=02&d=20200623&t=2&i=1523208318&r=LYNXMPEG5M1D8&w=1280",
        publishedAt: "June 23, 2020, 3:27 PM",
        source: {
            url: "https://www.reuters.com/",
            name: "Reuters"
        },
    },
    {
        title: "Everything you need to know about hepatitis B",
        description: 'Hepatitis B is an infection of the liver caused by the hepatitis B virus (HBV). It can be acute and resolve without treatment. However, some forms can be chronic, and these could lead to cirrhosis and liver cancer.',
        url: "https://www.medicalnewstoday.com/articles/306288",
        image: "https://cdn-prod.medicalnewstoday.com/content/images/articles/306/306288/a-woman-in-a-yellow-beanie-hate-walking-down-a-street-with-graffiti.jpg",
        publishedAt: "November 7, 2019",
        source: {
            url: "https://www.medicalnewstoday.com/",
            name: "Medical News Today"
        },
    },
    {
        title: "Climate change and health: Impacts and risks",
        description: 'Climate change affects human health in a variety of ways. Extreme changes in the weather and environment can increase existing health problems, as well as creating new ones.',
        url: "https://www.medicalnewstoday.com/articles/climate-change-and-health",
        image: "https://post.medicalnewstoday.com/wp-content/uploads/sites/3/2020/01/GettyImages-1143505323_hero-1024x575.jpg",
        publishedAt: "February 7, 2020",
        source: {
            url: "https://www.medicalnewstoday.com/",
            name: "Medical News Today"
        },
    },
    {
        title: "Causes, symptoms, and treatment of hepatitis A",
        description: 'Hepatitis A is a virus that causes infection and inflammation of the liver. It rarely results in serious liver damage or death and does not develop chronic liver disease.',
        url: "https://www.medicalnewstoday.com/articles/308421",
        image: "https://cdn-prod.medicalnewstoday.com/content/images/articles/308/308421/hepatitis-a.jpg",
        publishedAt: "October 18, 2017",
        source: {
            url: "https://www.medicalnewstoday.com/",
            name: "Medical News Today"
        },
    },
    {
        title: "Dengue Now Evading Vaccines and Therapeutics",
        description: 'Singapore saw 1,158 dengue cases in the week ending 13 June 2020, the highest number of weekly dengue cases ever recorded since 2014. The dengue virus serotype 3 (DENV3), which is currently circulating in Singapore, can undergo dramatic structural changes that enable it to resist vaccines and therapeutics, reveal findings from a new study.',
        url: "https://www.sciencedaily.com/releases/2020/06/200623104236.htm",
        image: "https://cdn-images.rtp.pt/icm/noticias/images/c4/c46d7f8e551e2f22cc776cb74e0f261a?w=860&q=90&rect=0,91,1500,822&auto=format",
        publishedAt: "June 23, 2020",
        source: {
            url: "https://www.sciencedaily.com/",
            name: "Science Daily"
        },
    },
    {
        title: "Health agencies urge continuation of life-saving measles vaccinations",
        description: 'Over the past years, several measles outbreaks have cropped up across the globe. The most recent one in the United States was in 2019, where 1,282 people were confirmed in 31 states. Of these cases, 128 were hospitalized, and 61 had complications, including encephalitis and pneumonia.',
        url: "https://www.news-medical.net/news/20200415/Health-agencies-urge-continuation-of-life-saving-measles-vaccinations.aspx",
        image: "https://www.news-medical.net/image.axd?picture=2020%2f4%2f%40Capture-4.jpg&ts=20200415010606&ri=674",
        publishedAt: "Apr 15 2020",
        source: {
            url: "https://www.medicalnewstoday.com/",
            name: "News Medical"
        },
    },
    {
        title: "Experimental vaccine could be effective against both Zika and Dengue",
        description: 'The team of researchers revealed that this experimental Zika virus vaccine was capable of boosting an immunity provided by flavivirus by producing cross-neutralizing antibody responses against dengue as well as Zika virus.',
        url: "https://www.news-medical.net/news/20200203/Experimental-vaccine-could-be-effective-against-both-Zika-and-Dengue.aspx",
        image: "https://www.news-medical.net/image.axd?picture=2020%2f2%2f%40shutterstock_368194520.jpg&ts=20200203062958&ri=674",
        publishedAt: "Feb 3 2020",
        source: {
            url: "https://www.medicalnewstoday.com/",
            name: "News Medical"
        },
    }
]


export default ENHealth